import { CSSProperties, styled } from "styled-components";

import { Card } from "../Card";
import { Icon } from "../Icon";

const BUTTON_SIZE = 42;
export const CAROUSEL_GUTTER_WIDTH = 12;

interface ButtonContainerProps {
  $visible: boolean;
  $alignment: "left" | "right";
}

export const ButtonContainer = styled.span<ButtonContainerProps>(
  ({ theme, $visible, $alignment }) => {
    const visibleStyles: CSSProperties = {
      opacity: $visible ? 1 : 0,
      pointerEvents: $visible ? "auto" : "none",
    };

    const alignmentStyles = {
      left: {
        left: theme.space[2],
      },
      right: {
        right: theme.space[2],

        [`& ${Icon.Frame}`]: {
          transform: "scaleX(-1)",
        },
      },
    };

    return {
      position: "absolute",
      zIndex: 1,

      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: theme.radii.round,
      transition: "transform 250ms, box-shadow 250ms, opacity 250ms",
      transform: "translateY(-50%)",
      top: "50%",

      height: BUTTON_SIZE,
      width: BUTTON_SIZE,
      cursor: "pointer",
      backgroundColor: theme.colors.white,
      color: theme.colors.black,
      boxShadow: `0 1px 3px 1px ${theme.shadows[1]}, 0 0 0 1px ${theme.shadows[3]}, 0 2px 4px -3px ${theme.shadows[12]}, 0 5px 8px -8px ${theme.shadows[12]}`,
      border: "none",

      [`& ${Icon.Frame}`]: {
        height: theme.sizes.xxs,
        width: theme.sizes.xxs,
        color: "rgba(0,0,0,0.6)",
        trans: ["color"],
      },

      [`&:hover`]: {
        boxShadow: `0 1px 4px 1px ${theme.shadows[4]}, 0 0 0 1px ${theme.shadows[4]}, 0 2px 4px -3px ${theme.shadows[12]}, 0 5px 8px -8px ${theme.shadows[12]}`,
      },

      [`&:active`]: {
        boxShadow: `0 1px 4px 1px ${theme.shadows[8]}, 0 0 0 1px ${theme.shadows[4]}, 0 2px 4px -3px ${theme.shadows[12]}, 0 5px 8px -8px ${theme.shadows[12]}`,
      },

      [`
      &:hover ${Icon.Frame},
      &:active ${Icon.Frame}
    `]: {
        color: "rgba(0,0,0,0.8)",
      },

      ...visibleStyles,
      ...alignmentStyles[$alignment],
    };
  },
);

export const Container = styled.div(() => {
  return {
    display: "flex",
    whiteSpace: "nowrap",

    [`& ${Card.Container}`]: {
      height: "fit-content",
      flexShrink: 0,
      marginLeft: CAROUSEL_GUTTER_WIDTH,

      "&:first-of-type": {
        marginLeft: 0,
      },
    },
  };
});
